module.exports = __webpack_public_path__ + "img/4.b7ce9926.jpg";